module.exports = __webpack_public_path__ + "static/media/8707.e6702680.png";